import { APAC_CHECKOUT_NAME, ApacCheckoutComponent } from "@apac/checkout";
import { APAC_HOTEL_NAME, ApacHotelsComponent } from "@apac/components/hotels";
import { APAC_FORM_UI_NAME, ApacFormUiComponent } from "@apac/form-ui";
import { APAC_TRAVELERS_NAME, ApacTravelersComponent } from "@apac/travelers";
import {
  CORE_ACTIVITIES_NAME,
  CORE_DISRUPTION_NAME,
  CORE_FLIGHTS_NAME,
  CORE_HOTELS_NAME,
  CORE_PACKAGES_NAME,
  CORE_SELF_SERVE_NAME,
  CORE_TRIPS_NAME,
  CORE_UI_NAME,
  CoreActivitiesComponent,
  CoreDisruptionComponent,
  CoreFlightsComponent,
  CoreHotelsComponent,
  CorePackagesComponent,
  CoreSelfServeComponent,
  CoreTripsComponent,
  CoreUiComponents,
  CORE_FLIGHTS_CFAR_NAME,
  CORE_HOTELS_CFAR_NAME,
} from "@b2bportal/core-types";
import { CHAT_NAME, ChatComponents } from "@hopper-b2b/chat";
import {
  activityAvailabilityTitleStyles,
  activitiesSearchPageStyles,
  activitiesShopPageStyles,
  activityInfoSectionStyles,
  activityReviewsSectionStyles,
  activityShopSectionStyles,
  activityShopTabsStyles,
  activityMeetupSectionStyles,
  activityItinerarySectionStyles,
  activityBookingOptionsStyles,
  imageGalleryStyles,
} from "./activities/styles";

import { CheckoutPaymentFormStyles } from "./apac/apac-checkout/styles";
import {
  FormInputContainerStyles,
  PhoneNumberFieldStyles,
  SelectFieldStyles,
} from "./apac/apac-form-ui/styles";
import {
  RewardsAndCreditStyles,
  fintechPriceBreakdownSectionStyles,
} from "./apac/apac-hotels/styles";
import {
  DriverLicenseStyles,
  FrequentFlyerDetailsStyles,
  PassportDetailsStyles,
  AdditionalInfoStyles,
} from "./apac/apac-travelers/styles";
import {
  FilterBagsStyles,
  FilterCancellationStyles,
  FilterCarTypeStyles,
  FilterPassengersStyles,
  FilterSpecificationStyles,
  FilterSuppliersStyles,
  CarCardStyles,
  CancellationPillStyles,
  CarAvailabilityCardStyles,
  CarShopSectionStyles,
  VendorMessageStyles,
  CarAttributePillStyles,
  CarAvailabilitySearchStyles,
  CarsShopPageStyles,
} from "./cars/styles";
import { chatFabStyles } from "./chat/styles";
import disruptionFintechMarketplaceProductStyles from "./core-disruption/DisruptionFintechMarketplaceProduct/styles.module.scss";
import disruptionOfferSectionStyles from "./core-disruption/DisruptionOfferSection/styles.module.scss";
import howItWorksDialogStyles from "./core-disruption/HowItWorksDialog/styles.module.scss";
import { CORE_DISRUPTION_STYLE_OVERRIDES } from "./core-disruption/styles";
import { CORE_FINTECH_UI_STYLE_OVERRIDES } from "./core-fintech-ui/styles";
import { CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES } from "./core-flights-cfar-exercise/styles";
import { CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES } from "./core-flights-cfar-offers/styles";
import resendEmailModalStyles from "./core-self-serve/ResendEmailModal/ResendEmailModal.module.scss";
import dialogStyles from "./core-ui/Dialog/styles.module.scss";
import {
  languageSelectorStyles,
  currencySelectorStyles,
  iframeDialogStyles,
  pageHeaderStyles,
  pageStyles,
  selectStyles,
  mapMarkerStyles,
  carouselSliderDotsStyles,
  timePickerStyles,
  datePickerDayStyles,
  cardStyles,
  priceBreakdownStyles,
  datePickerMonthStyles,
  breadcrumbsStyles,
  calendarPriceRangeTagsStyles,
  filterPriceStyles,
  checkboxGroupStyles,
  checkboxStyles,
  infoBannerStyles,
  tripsAppPageStyles,
  datePickerColumnViewStyles,
  importantInfoListStyles,
  skeletonLoadingStyles,
} from "./core-ui/styles";
import {
  sortStyles,
  flghtSummaryStyles,
  flightTimeStyles,
  flightFareGridItemStyles,
  flightCardFareSelectorStyles,
  flightDetailsStyles,
  fareListFareDetailsStyles,
  fareRestrictionsStyles,
  tripSummaryStyles,
  itinerarySummaryStyles,
  algomerchTagsStyles,
  flightDetailsSegmentStyles,
  flightCategorySelectionStyles,
  flightsFintechMarketplacePageInfoHeaderStyles,
  flightCardFareListItemStyles,
  passengerCountPickerStyles,
  countPickerStyles,
  flightScheduleChangeBannerStyles,
  searchPageStyles as flightsSearchPageStyles,
  flightExchangeStyles,
  flightSlicePickerModalStyles,
} from "./flights/styles";
import {
  hotelCardTagsStyles,
  hotelCardFeaturesStyles,
  imageCarouselArrowStyles,
  hotelCardRatingStyles,
  aboutHotelSectionStyles,
  amenitiesStyles,
  customerReviewsSectionStyles,
  hotelMapRedoSearchButtonStyles,
  hotelShopSectionStyles,
  shopPageStyles,
  hotelRoomCardStyles,
  hotelRoomSelectionStyles,
  hotelRoomCardDialogStyles,
  hotelRoomRateStyles,
  hotelMapMarkersStyles,
  tripAdvisorRatingStyles,
  hotelListSortStyles,
  checkInPoliciesSectionStyles,
  hotelCheckoutCardStyles,
  hotelAvailabilitySearchStyles,
  checkInInformationSectionStyles,
  hotelsFintechMarketplacePageInfoHeaderStyles,
  childAgePickerStyles,
} from "./hotels/styles";
import { CORE_HOTELS_CFAR_STYLE_OVERRIDES } from "./hotels-cfar/styles";
import { CORE_HOTELS_CFAR_EXERCISE_STYLE_OVERRIDES } from "./hotels-cfar-exercise/styles";
import {
  packageSelectRadioGroupStyles,
  packageFlightDeparturePageStyles,
} from "./packages/styles";
import { tripsListStyles } from "./trips/styles";
import { CORE_CARS_NAME, CoreCarsComponent } from "~core-cars/types";

export const styleOverrides = {
  ...CORE_FINTECH_UI_STYLE_OVERRIDES,
  [CORE_ACTIVITIES_NAME]: {
    [CoreActivitiesComponent.SearchPage]: activitiesSearchPageStyles,
    [CoreActivitiesComponent.ActivityAvailabilityTitle]:
      activityAvailabilityTitleStyles,
    [CoreActivitiesComponent.ActivityShopSection]: activityShopSectionStyles,
    [CoreActivitiesComponent.ActivityInfoSection]: activityInfoSectionStyles,
    [CoreActivitiesComponent.ActivityReviewsSection]:
      activityReviewsSectionStyles,
    [CoreActivitiesComponent.ShopPage]: activitiesShopPageStyles,
    [CoreActivitiesComponent.ActivityShopTabs]: activityShopTabsStyles,
    [CoreActivitiesComponent.ActivityMeetupSection]:
      activityMeetupSectionStyles,
    [CoreActivitiesComponent.ActivityItinerarySection]:
      activityItinerarySectionStyles,
    [CoreActivitiesComponent.ActivityBookingOptions]:
      activityBookingOptionsStyles,
  },
  [CORE_DISRUPTION_NAME]: {
    [CoreDisruptionComponent.DisruptionOfferSection]:
      disruptionOfferSectionStyles,
    [CoreDisruptionComponent.DisruptionFintechMarketplaceProduct]:
      disruptionFintechMarketplaceProductStyles,
    [CoreDisruptionComponent.HowItWorksDialog]: howItWorksDialogStyles,
    ...CORE_DISRUPTION_STYLE_OVERRIDES[CORE_DISRUPTION_NAME],
  },
  [CORE_UI_NAME]: {
    [CoreUiComponents.LanguageSelector]: languageSelectorStyles,
    [CoreUiComponents.CurrencySelector]: currencySelectorStyles,
    [CoreUiComponents.IframeDialog]: iframeDialogStyles,
    [CoreUiComponents.PageHeader]: pageHeaderStyles,
    [CoreUiComponents.Page]: pageStyles,
    [CoreUiComponents.Select]: selectStyles,
    [CoreUiComponents.MapMarker]: mapMarkerStyles,
    [CoreUiComponents.CarouselSliderDots]: carouselSliderDotsStyles,
    [CoreUiComponents.TimePicker]: timePickerStyles,
    [CoreUiComponents.Dialog]: dialogStyles,
    [CoreUiComponents.Card]: cardStyles,
    [CoreUiComponents.PriceBreakdown]: priceBreakdownStyles,
    [CoreUiComponents.DatePickerDay]: datePickerDayStyles,
    [CoreUiComponents.DatePickerMonth]: datePickerMonthStyles,
    [CoreUiComponents.Breadcrumbs]: breadcrumbsStyles,
    [CoreUiComponents.CalendarPriceRangeTags]: calendarPriceRangeTagsStyles,
    [CoreUiComponents.CheckboxGroup]: checkboxGroupStyles,
    [CoreUiComponents.Checkbox]: checkboxStyles,
    [CoreUiComponents.InfoBanner]: infoBannerStyles,
    [CoreUiComponents.ImportantInfoList]: importantInfoListStyles,
    [CoreUiComponents.TripsAppPage]: tripsAppPageStyles,
    [CoreUiComponents.DatePickerColumnView]: datePickerColumnViewStyles,
    [CoreUiComponents.SkeletonLoading]: skeletonLoadingStyles,
  },
  [CORE_FLIGHTS_NAME]: {
    [CoreFlightsComponent.Sort]: sortStyles,
    [CoreFlightsComponent.FlightSummary]: flghtSummaryStyles,
    [CoreFlightsComponent.FlightTime]: flightTimeStyles,
    [CoreFlightsComponent.FlightFareGridItem]: flightFareGridItemStyles,
    [CoreFlightsComponent.FlightCardFareSelector]: flightCardFareSelectorStyles,
    [CoreFlightsComponent.FlightDetails]: flightDetailsStyles,
    [CoreFlightsComponent.FareListFareDetails]: fareListFareDetailsStyles,
    [CoreFlightsComponent.FareRestrictions]: fareRestrictionsStyles,
    [CoreFlightsComponent.TripSummary]: tripSummaryStyles,
    [CoreFlightsComponent.ItinerarySummary]: itinerarySummaryStyles,
    [CoreFlightsComponent.FilterPrice]: filterPriceStyles,
    [CoreFlightsComponent.AlgomerchTags]: algomerchTagsStyles,
    [CoreFlightsComponent.FlightDetailsSegment]: flightDetailsSegmentStyles,
    [CoreFlightsComponent.FlightCategorySelection]:
      flightCategorySelectionStyles,
    [CoreFlightsComponent.FlightsFintechMarketplacePageInfoHeader]:
      flightsFintechMarketplacePageInfoHeaderStyles,
    [CoreFlightsComponent.FlightCardFareListItem]: flightCardFareListItemStyles,
    [CoreFlightsComponent.PassengerCountPicker]: passengerCountPickerStyles,
    [CoreFlightsComponent.CountPicker]: countPickerStyles,
    [CoreFlightsComponent.FlightScheduleChangeBanner]:
      flightScheduleChangeBannerStyles,
    [CoreFlightsComponent.SearchPage]: flightsSearchPageStyles,
    [CoreFlightsComponent.FlightExchange]: flightExchangeStyles,
    [CoreFlightsComponent.FlightSlicePickerModal]: flightSlicePickerModalStyles,
  },
  [CORE_CARS_NAME]: {
    [CoreCarsComponent.FilterCancellation]: FilterCancellationStyles,
    [CoreCarsComponent.FilterCarType]: FilterCarTypeStyles,
    [CoreCarsComponent.FilterSuppliers]: FilterSuppliersStyles,
    [CoreCarsComponent.FilterPassenger]: FilterPassengersStyles,
    [CoreCarsComponent.FilterBags]: FilterBagsStyles,
    [CoreCarsComponent.FilterSpecification]: FilterSpecificationStyles,
    [CoreCarsComponent.CarCard]: CarCardStyles,
    [CoreCarsComponent.CancellationPill]: CancellationPillStyles,
    [CoreCarsComponent.CarAvailabilityCard]: CarAvailabilityCardStyles,
    [CoreCarsComponent.CarShopSection]: CarShopSectionStyles,
    [CoreCarsComponent.VendorMessages]: VendorMessageStyles,
    [CoreCarsComponent.CarAttributePill]: CarAttributePillStyles,
    [CoreCarsComponent.CarAvailabilitySearch]: CarAvailabilitySearchStyles,
    [CoreCarsComponent.ShopPage]: CarsShopPageStyles,
  },
  [CORE_HOTELS_NAME]: {
    [CoreHotelsComponent.ShopPage]: shopPageStyles,
    [CoreHotelsComponent.HotelMapRedoSearchButton]:
      hotelMapRedoSearchButtonStyles,
    [CoreHotelsComponent.HotelCardTags]: hotelCardTagsStyles,
    [CoreHotelsComponent.HotelCardFeatures]: hotelCardFeaturesStyles,
    [CoreHotelsComponent.ImageCarouselArrow]: imageCarouselArrowStyles,
    [CoreHotelsComponent.HotelCardRating]: hotelCardRatingStyles,
    [CoreHotelsComponent.HotelShopSection]: hotelShopSectionStyles,
    [CoreHotelsComponent.Amenities]: amenitiesStyles,
    [CoreHotelsComponent.AboutHotelSection]: aboutHotelSectionStyles,
    [CoreHotelsComponent.CustomerReviewsSection]: customerReviewsSectionStyles,
    [CoreHotelsComponent.HotelRoomCard]: hotelRoomCardStyles,
    [CoreHotelsComponent.HotelRoomSelection]: hotelRoomSelectionStyles,
    [CoreHotelsComponent.HotelRoomCardDialog]: hotelRoomCardDialogStyles,
    [CoreHotelsComponent.HotelRoomRate]: hotelRoomRateStyles,
    [CoreHotelsComponent.HotelMapMarkers]: hotelMapMarkersStyles,
    [CoreHotelsComponent.TripAdvisorRating]: tripAdvisorRatingStyles,
    [CoreHotelsComponent.HotelListSort]: hotelListSortStyles,
    [CoreHotelsComponent.CheckInPoliciesSection]: checkInPoliciesSectionStyles,
    [CoreHotelsComponent.HotelCheckoutCard]: hotelCheckoutCardStyles,
    [CoreHotelsComponent.HotelAvailabilitySearch]:
      hotelAvailabilitySearchStyles,
    [CoreHotelsComponent.CheckInInformationSection]:
      checkInInformationSectionStyles,
    [CoreHotelsComponent.HotelsFintechMarketplacePageInfoHeader]:
      hotelsFintechMarketplacePageInfoHeaderStyles,
    [CoreHotelsComponent.ImageGallery]: imageGalleryStyles,
    [CoreHotelsComponent.ChildAgePicker]: childAgePickerStyles,
  },
  [APAC_FORM_UI_NAME]: {
    [ApacFormUiComponent.PhoneNumberField]: PhoneNumberFieldStyles,
    [ApacFormUiComponent.FormInputContainer]: FormInputContainerStyles,
    [ApacFormUiComponent.SelectField]: SelectFieldStyles,
  },
  [APAC_TRAVELERS_NAME]: {
    [ApacTravelersComponent.DriverLicense]: DriverLicenseStyles,
    [ApacTravelersComponent.PassportDetails]: PassportDetailsStyles,
    [ApacTravelersComponent.FrequentFlyerDetails]: FrequentFlyerDetailsStyles,
    [ApacTravelersComponent.AdditionalInfo]: AdditionalInfoStyles,
  },
  [APAC_CHECKOUT_NAME]: {
    [ApacCheckoutComponent.CheckoutPaymentForm]: CheckoutPaymentFormStyles,
  },
  [APAC_HOTEL_NAME]: {
    [ApacHotelsComponent.RewardsAndCredit]: RewardsAndCreditStyles,
    [ApacHotelsComponent.FintechPriceBreakdownSection]:
      fintechPriceBreakdownSectionStyles,
  },
  [CORE_PACKAGES_NAME]: {
    [CorePackagesComponent.PackageSelectRadioGroup]:
      packageSelectRadioGroupStyles,
    [CorePackagesComponent.PackageFlightDeparturePage]:
      packageFlightDeparturePageStyles,
  },
  [CORE_TRIPS_NAME]: {
    [CoreTripsComponent.TripsList]: tripsListStyles,
  },
  [CORE_SELF_SERVE_NAME]: {
    [CoreSelfServeComponent.ResendEmailModal]: resendEmailModalStyles,
  },
  [CHAT_NAME]: {
    [ChatComponents.ChatFab]: chatFabStyles,
  },
  [CORE_FLIGHTS_CFAR_NAME]: {
    ...CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES[CORE_FLIGHTS_CFAR_NAME],
    ...CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES[CORE_FLIGHTS_CFAR_NAME],
  },
  [CORE_HOTELS_CFAR_NAME]: {
    ...CORE_HOTELS_CFAR_STYLE_OVERRIDES[CORE_HOTELS_CFAR_NAME],
    ...CORE_HOTELS_CFAR_EXERCISE_STYLE_OVERRIDES[CORE_HOTELS_CFAR_NAME],
  },
};
